import { Directive, ElementRef, EventEmitter, HostListener, Output } from "@angular/core";
import { CoreCOMService } from "../../services/com.service";
import { CoreLanguageService } from "../../services/language.service";

@Directive({
  selector: "[numericInput]"
})
export class NumericInputDirective {

  @Output("custom-keyup") customKeyUp: EventEmitter<any> = new EventEmitter();

  constructor(el: ElementRef
    , private _coreLanguageService: CoreLanguageService
    , private _coreCOMService: CoreCOMService) {

  }

  @HostListener("keydown", ["$event"])
  public isNumberKey(event: any) {
    const me = this;
    const isDeutsch = me._coreLanguageService.getCurrentLanguage() === "de";
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode === 13) {
      event.target.blur();
      event.preventDefault();
    } else if (charCode === 8 || charCode === 46 || (charCode >= 35 && charCode <= 37) || charCode === 39) {
      return true;
    } else if ((charCode >= 48 && charCode <= 57) || (charCode >= 96 && charCode <= 105) || charCode === 188 || charCode === 110 || charCode === 190) {
      const regexp = isDeutsch ? /^[+-]?(?=.?\d)\d*(\,\d{0,2})?$/ : /^[+-]?(?=.?\d)\d*(\.\d{0,2})?$/;
      if (regexp.test(event.target.value.slice(0, event.target.selectionStart) + event.key + event.target.value.slice(event.target.selectionStart))) {
        return true;
      } else {
        event.preventDefault();
      }
    } else {
      event.preventDefault();
    }
  }

  @HostListener("keyup", ["$event"])
  public isNumberKeyMobilecheck(event: any): void {
    const me = this;
    // mobile keyCode for charachter is different
    if (me._coreCOMService.environment.client.isMobile) {
      const isDeutsch = me._coreLanguageService.getCurrentLanguage() === "de";
      const regexp = isDeutsch ? /^[+-]?(?=.?\d)\d*(\,\d{0,2})?$/ : /^[+-]?(?=.?\d)\d*(\.\d{0,2})?$/;
      if (!regexp.test(event.target.value)) {
        const selectionStart = event.target.selectionStart - 1;
        event.target.value = event.target.value.slice(0, event.target.selectionStart - 1) + event.target.value.slice(event.target.selectionStart);
        event.target.selectionStart = selectionStart;
        event.target.selectionEnd = selectionStart;
      }
    }
    me.customKeyUp.emit(event.target.value);
  }

}
